import styled from '@emotion/styled';
import { LogoWordmarkBrand } from '@eventbrite/eds-iconography';
import React from 'react';
import { UI_COLORS } from './constants';

export const FormHeader: React.FC = () => {
    return (
        <Container>
            <Logo />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`;

const Logo = styled(LogoWordmarkBrand)`
    width: 110px;
    fill: ${UI_COLORS['primary-brand']};
`;
